"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpgradeDialog = void 0;

var _ = require("../../");

var _upgradeDialogBanner = _interopRequireDefault(require("../../assets/img/upgrade-dialog-banner.png"));

var _BillingIntervalSelector = require("./BillingIntervalSelector");

require("./UpgradeDialog.css");

var _react = _interopRequireWildcard(require("react"));

var _excluded = ["title", "buttonTitle", "features", "contentTitle", "costText", "cancelText", "onClose", "upgradeeFullName", "upgradeeEmail", "defaultBillingInterval", "onUpgradeClick"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// Upgrade Dialog
var UpgradeDialog = function UpgradeDialog(_ref) {
  var title = _ref.title,
      buttonTitle = _ref.buttonTitle,
      features = _ref.features,
      contentTitle = _ref.contentTitle,
      costText = _ref.costText,
      cancelText = _ref.cancelText,
      onClose = _ref.onClose,
      upgradeeFullName = _ref.upgradeeFullName,
      upgradeeEmail = _ref.upgradeeEmail,
      defaultBillingInterval = _ref.defaultBillingInterval,
      onUpgradeClick = _ref.onUpgradeClick,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)(defaultBillingInterval),
      _useState2 = _slicedToArray(_useState, 2),
      billingInterval = _useState2[0],
      setBillingInterval = _useState2[1];

  var handleOnClose = function handleOnClose(e) {
    if (typeof onClose === "function") {
      onClose(e);
    }
  };

  var handleOnUpgradeClick = function handleOnUpgradeClick(e, aBillingInterval) {
    if (typeof onUpgradeClick === "function") {
      onUpgradeClick(e, aBillingInterval);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_.Modal, _extends({
    trkContext: "Upgrade Trace ID",
    className: "UpgradeDialog",
    open: true,
    onShadeClick: function onShadeClick(e) {
      return handleOnClose(e);
    }
  }, props), /*#__PURE__*/_react.default.createElement(_.TitleSection, {
    className: "header"
  }, /*#__PURE__*/_react.default.createElement(_.Label, {
    className: "title",
    type: _.Label.Type.Heading4,
    content: title,
    span: 12
  }), /*#__PURE__*/_react.default.createElement(_.RoundButton, {
    trkAction: "Close Pressed",
    className: "button-close",
    borderColor: _.Color.White2,
    icon: _.Icon.Type.Close,
    color: _.Color.Grey3,
    onClick: function onClick(e) {
      return handleOnClose(e);
    },
    iconSize: 30
  })), /*#__PURE__*/_react.default.createElement(_.ContentSection, {
    className: "body",
    background: _.Color.White1
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _upgradeDialogBanner.default,
    alt: "Upgrade Banner",
    width: "100%"
  }), /*#__PURE__*/_react.default.createElement(_.Column, {
    padding: "6 8"
  }, /*#__PURE__*/_react.default.createElement(_.Label, {
    type: _.Label.Type.Heading2,
    marginBottom: "4"
  }, contentTitle), /*#__PURE__*/_react.default.createElement(_.Label, {
    type: _.Label.Type.Body,
    marginBottom: "4"
  }, "Everything that's included in Trace iD and:"), /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-features"
  }, features.map(function (feature, index) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: "upgrade-dialog-li-".concat(index)
    }, /*#__PURE__*/_react.default.createElement(_.Label, {
      className: "feature",
      bold: true,
      type: _.Label.Type.Body
    }, feature));
  })), /*#__PURE__*/_react.default.createElement(_BillingIntervalSelector.BillingIntervalSelector, {
    selectedBillingInterval: billingInterval,
    setSelectedBillingInterval: setBillingInterval,
    upgradeeFullName: upgradeeFullName,
    upgradeeEmail: upgradeeEmail
  }))), /*#__PURE__*/_react.default.createElement(_.FooterSection, null, /*#__PURE__*/_react.default.createElement(_.Column, {
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_.Button, {
    trkAction: "Upgrade Pressed",
    primary: true,
    width: "274px",
    className: "button-upgrade",
    content: /*#__PURE__*/_react.default.createElement(_.Row, {
      className: "content"
    }, /*#__PURE__*/_react.default.createElement(_.Icon, {
      type: _.Icon.Type.Upgrade
    }), /*#__PURE__*/_react.default.createElement(_.Label, {
      marginLeft: "2"
    }, buttonTitle)),
    onClick: function onClick(e) {
      return handleOnUpgradeClick(e, billingInterval);
    }
  }))));
};

exports.UpgradeDialog = UpgradeDialog;
UpgradeDialog.defaultProps = {
  defaultBillingInterval: "yearly",
  upgradeeFullName: "Some One",
  title: "Unlock more features",
  buttonTitle: "Upgrade now",
  costText: "$9.99 per month ($99 per year)",
  cancelText: "Cancel any time",
  contentTitle: "Trace iD+",
  features: ["Unlimited playlists with unlimited moments", "Privacy controls", "Upload your own video", "Download playlists as one video"]
};